import {createSelector} from 'reselect'
import {NEW_ID} from '../../../common/constants/index.js'
import {QUICK_BOOKS} from '../../../common/constants/Integrations.js'
import {ACCOUNTING, SETTINGS} from '../../../common/constants/SettingsPanels.js'
import {isPositiveNumeric} from '../../../common/utils.js'
import {locationSelector} from '../../../redux/selectors/ui/location.js'

export const settingsAccountingEditIDSelector = createSelector(
  locationSelector,
  ({pathComponents}) => {
    if (
      pathComponents[0] === SETTINGS &&
      pathComponents[1] === ACCOUNTING &&
      isPositiveNumeric(pathComponents[2])
    ) {
      return Number(pathComponents[2])
    }

    return null
  },
)

export const settingsAccountingAddSelector = createSelector(
  locationSelector,
  ({pathComponents}) => {
    return (
      pathComponents[0] === SETTINGS &&
      pathComponents[1] === ACCOUNTING &&
      pathComponents[2] === NEW_ID
    )
  },
)

export function accountingIntegrationOptionsSelector() {
  return [{value: QUICK_BOOKS, display: 'QuickBooks'}]
}
